(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kvsche-cooling-unit-product-page"]) return;
  try {
    
  class KvscheCoolingUnitProduct extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      this.productForm = this.querySelector('product-form-component');
      this.variantSelect = this.querySelector('[data-cooling-variant-select]');
      this.price = this.querySelector('[data-cooling-price]');
      this.stock = this.querySelector('[data-cooling-stock]');
      this.addButton = this.querySelector('[ref="addToCartButton"]');
      this.addText = this.querySelector('.kv-cooling-unit__add-text');
      this.quantityInput = this.querySelector('quantity-selector-component input[name="quantity"]');
      this.quantityComponent = this.querySelector('quantity-selector-component');
      this.stickyBuy = this.querySelector('[data-cooling-sticky-buy]');
      this.stickyButton = this.querySelector('[data-cooling-sticky-button]');
      this.stickyPrice = this.querySelector('[data-cooling-sticky-price]');
      this.variants = this.readVariants();

      this.setupHeroCarousel();
      this.setupMotion();
      this.setupCartDrawer();
      this.setupStickyBuy();

      if (!this.variantSelect || !this.variants.length) return;

      this.variantSelect.addEventListener('change', () => {
        this.updateVariant(this.variantSelect.value);
      }, { signal: this.abortController.signal });
    }

    disconnectedCallback() {
      this.abortController?.abort();
      if (this.cartUpdateHandler) {
        document.removeEventListener('shopify:cart:lines-update', this.cartUpdateHandler);
      }
      this.purchaseObserver?.disconnect();
      this.revealObserver?.disconnect();
      this.heroAnimations?.forEach((animation) => animation.cancel());
      this.slideAnimations?.forEach((animation) => animation.cancel());
    }

    setupHeroCarousel() {
      this.heroGallery = this.querySelector('[data-cooling-gallery]');
      this.heroSlides = Array.from(this.querySelectorAll('[data-cooling-slide]'));
      this.heroDots = Array.from(this.querySelectorAll('[data-cooling-slide-dot]'));
      this.heroCurrent = this.querySelector('[data-cooling-slide-current]');
      this.currentSlideIndex = 0;
      this.slideAnimations = [];

      if (!this.heroGallery || this.heroSlides.length < 2) return;

      const signal = this.abortController.signal;
      this.querySelector('[data-cooling-slide-previous]')?.addEventListener('click', () => this.showHeroSlide(this.currentSlideIndex - 1, -1), { signal });
      this.querySelector('[data-cooling-slide-next]')?.addEventListener('click', () => this.showHeroSlide(this.currentSlideIndex + 1, 1), { signal });

      this.heroDots.forEach((dot, index) => {
        dot.addEventListener('click', () => this.showHeroSlide(index, index >= this.currentSlideIndex ? 1 : -1), { signal });
      });

      this.heroGallery.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          this.showHeroSlide(this.currentSlideIndex - 1, -1);
        }
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          this.showHeroSlide(this.currentSlideIndex + 1, 1);
        }
      }, { signal });

      let pointerStart = null;
      this.heroGallery.addEventListener('pointerdown', (event) => {
        if (event.pointerType === 'mouse') return;
        pointerStart = event.clientX;
      }, { signal, passive: true });
      this.heroGallery.addEventListener('pointerup', (event) => {
        if (pointerStart === null || event.pointerType === 'mouse') return;
        const distance = event.clientX - pointerStart;
        pointerStart = null;
        if (Math.abs(distance) < 44) return;
        this.showHeroSlide(this.currentSlideIndex + (distance < 0 ? 1 : -1), distance < 0 ? 1 : -1);
      }, { signal, passive: true });
    }

    hydrateHeroSlide(slide) {
      if (!slide || slide.dataset.hydrated === 'true') return;

      slide.querySelectorAll('source[data-srcset]').forEach((source) => {
        source.srcset = source.dataset.srcset;
        source.removeAttribute('data-srcset');
      });

      const image = slide.querySelector('img[data-src]');
      if (image) {
        image.loading = 'eager';
        if (image.dataset.srcset) image.srcset = image.dataset.srcset;
        image.src = image.dataset.src;
        image.removeAttribute('data-src');
        image.removeAttribute('data-srcset');
      }
      slide.dataset.hydrated = 'true';
    }

    showHeroSlide(nextIndex, direction = 1) {
      const total = this.heroSlides.length;
      const normalizedIndex = (nextIndex + total) % total;
      if (normalizedIndex === this.currentSlideIndex) return;

      const outgoing = this.heroSlides[this.currentSlideIndex];
      const incoming = this.heroSlides[normalizedIndex];
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.slideAnimations.forEach((animation) => animation.cancel());
      this.slideAnimations = [];
      this.hydrateHeroSlide(incoming);

      this.heroSlides.forEach((slide, index) => {
        const isIncoming = index === normalizedIndex;
        slide.classList.toggle('is-active', isIncoming);
        slide.classList.remove('is-leaving');
        slide.setAttribute('aria-hidden', String(!isIncoming));
      });
      outgoing.classList.add('is-leaving');

      if (!reduceMotion && 'animate' in incoming) {
        const revealFrom = direction > 0 ? 'inset(0 0 0 100%)' : 'inset(0 100% 0 0)';
        this.slideAnimations.push(
          incoming.animate(
            [{ clipPath: revealFrom }, { clipPath: 'inset(0 0 0 0)' }],
            { duration: 900, easing: 'cubic-bezier(0.16, 1, 0.3, 1)' }
          ),
          incoming.querySelector('img').animate(
            [{ transform: `scale(1.08) translateX(${direction * 1.5}%)` }, { transform: 'scale(1) translateX(0)' }],
            { duration: 1200, easing: 'cubic-bezier(0.16, 1, 0.3, 1)' }
          ),
          outgoing.querySelector('img').animate(
            [{ transform: 'scale(1)', opacity: 1 }, { transform: 'scale(1.035)', opacity: 0.45 }],
            { duration: 720, easing: 'cubic-bezier(0.4, 0, 1, 1)' }
          )
        );
      }

      window.setTimeout(() => outgoing.classList.remove('is-leaving'), reduceMotion ? 0 : 920);
      this.currentSlideIndex = normalizedIndex;
      if (this.heroCurrent) this.heroCurrent.textContent = String(normalizedIndex + 1).padStart(2, '0');
      this.heroDots.forEach((dot, index) => {
        if (index === normalizedIndex) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    }

    setupMotion() {
      if (this.dataset.coolingMotion !== 'true') return;

      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const revealItems = this.querySelectorAll('[data-cooling-reveal]');
      this.classList.add('is-motion-ready');

      if (reduceMotion || !('IntersectionObserver' in window)) {
        revealItems.forEach((item) => item.classList.add('is-visible'));
        return;
      }

      this.playHeroEntrance();

      this.revealObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          this.revealObserver.unobserve(entry.target);
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

      revealItems.forEach((item) => this.revealObserver.observe(item));
    }

    playHeroEntrance() {
      if (!('animate' in Element.prototype)) return;

      const activeImage = this.querySelector('[data-cooling-slide].is-active img');
      const story = this.querySelector('[data-cooling-hero-story]');
      const technical = this.querySelector('[data-cooling-hero-technical]');
      const commerce = this.querySelector('[data-cooling-hero-commerce]');
      const controls = this.querySelector('[data-cooling-hero-controls]');
      const storyItems = story ? Array.from(story.children) : [];
      const factItems = technical ? Array.from(technical.querySelectorAll('.kv-cooling-unit__quick-fact')) : [];
      this.heroAnimations = [];

      const animate = (node, keyframes, timing) => {
        if (!node) return;
        this.heroAnimations.push(node.animate(keyframes, { fill: 'backwards', ...timing }));
      };

      animate(activeImage, [{ transform: 'scale(1.13)' }, { transform: 'scale(1)' }], {
        duration: 1800,
        delay: 100,
        easing: 'cubic-bezier(0.16, 1, 0.3, 1)',
      });

      storyItems.forEach((item, index) => {
        const isHeading = item.matches('h1');
        animate(item,
          [
            { opacity: 0, transform: isHeading ? 'translateY(58px)' : 'translateX(-34px)' },
            { opacity: 1, transform: 'translate3d(0, 0, 0)' },
          ],
          {
            duration: isHeading ? 1100 : 760,
            delay: 180 + (index * 105),
            easing: isHeading ? 'cubic-bezier(0.16, 1, 0.3, 1)' : 'cubic-bezier(0.22, 0.61, 0.36, 1)',
          }
        );
      });

      animate(technical, [{ opacity: 0, transform: 'translateY(48px)' }, { opacity: 1, transform: 'translateY(0)' }], {
        duration: 820,
        delay: 680,
        easing: 'cubic-bezier(0.16, 1, 0.3, 1)',
      });
      factItems.forEach((item, index) => animate(item,
        [{ opacity: 0, transform: 'translateY(18px)' }, { opacity: 1, transform: 'translateY(0)' }],
        { duration: 620, delay: 720 + (index * 75), easing: 'cubic-bezier(0.22, 0.61, 0.36, 1)' }
      ));
      animate(commerce, [{ opacity: 0, translate: '54px 0' }, { opacity: 1, translate: '0 0' }], {
        duration: 820,
        delay: 220,
        easing: 'cubic-bezier(0.16, 1, 0.3, 1)',
      });
      animate(controls, [{ opacity: 0, transform: 'translateY(20px)' }, { opacity: 1, transform: 'translateY(0)' }], {
        duration: 680,
        delay: 980,
        easing: 'cubic-bezier(0.22, 0.61, 0.36, 1)',
      });
    }

    setupCartDrawer() {
      if (this.dataset.openCartAfterAdd !== 'true' || !this.productForm) return;

      this.cartUpdateHandler = (event) => {
        if (event.target !== this.productForm || !event.promise) return;

        event.promise
          .then(({ detail }) => {
            if (detail?.didError) return;
            document.querySelector('cart-drawer-component')?.open();
          })
          .catch(() => {});
      };

      document.addEventListener('shopify:cart:lines-update', this.cartUpdateHandler);
    }

    setupStickyBuy() {
      if (!this.stickyBuy || !this.stickyButton || !this.addButton) return;

      this.stickyBuy.classList.add('is-hidden');
      this.stickyBuy.hidden = false;
      this.stickyButton.addEventListener('click', () => this.addButton.click(), { signal: this.abortController.signal });

      const purchase = this.querySelector('.kv-cooling-unit__purchase');
      if (!purchase || !('IntersectionObserver' in window)) return;

      this.purchaseObserver = new IntersectionObserver(([entry]) => {
        const purchaseIsAhead = entry.boundingClientRect.top > 0;
        this.stickyBuy.classList.toggle('is-hidden', entry.isIntersecting || purchaseIsAhead);
      }, { threshold: 0.15 });
      this.purchaseObserver.observe(purchase);
    }

    readVariants() {
      const script = this.querySelector('[data-cooling-variants]');
      if (!script?.textContent) return [];

      try {
        return JSON.parse(script.textContent);
      } catch (error) {
        console.error('Unable to parse cooling unit variants', error);
        return [];
      }
    }

    updateVariant(variantId) {
      const variant = this.variants.find((item) => String(item.id) === String(variantId));
      if (!variant) return;

      const formattedPrice = this.formatMoney(variant.price);

      if (this.price) this.price.textContent = formattedPrice;
      if (this.stickyPrice) this.stickyPrice.textContent = formattedPrice;
      if (this.stock) this.stock.textContent = variant.available ? 'In stock' : 'Sold out';
      if (this.addButton) this.addButton.disabled = !variant.available;
      if (this.stickyButton) this.stickyButton.disabled = !variant.available;
      if (this.addText) this.addText.textContent = variant.available ? 'Add to cart' : 'Sold out';
      if (this.productForm) this.productForm.dataset.quantityDefault = String(variant.quantity_rule?.min || 1);

      this.updateQuantity(variant);
      this.updateUrl(variant.id);
    }

    updateQuantity(variant) {
      const rule = variant.quantity_rule || {};
      const minimum = rule.min || 1;
      const increment = rule.increment || 1;

      if (this.quantityComponent) {
        this.quantityComponent.dataset.variantId = String(variant.id);
      }

      if (!this.quantityInput) return;

      this.quantityInput.value = String(minimum);
      this.quantityInput.min = String(minimum);
      this.quantityInput.dataset.min = String(minimum);
      this.quantityInput.step = String(increment);
      this.quantityInput.disabled = !variant.available;

      if (rule.max) {
        this.quantityInput.max = String(rule.max);
      } else {
        this.quantityInput.removeAttribute('max');
      }
    }

    updateUrl(variantId) {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variantId);
      window.history.replaceState({}, '', url.toString());
    }

    formatMoney(cents) {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: window.Shopify?.currency?.active || 'USD',
      }).format(cents / 100);
    }
  }

  if (!customElements.get('kvsche-cooling-unit-product')) {
    customElements.define('kvsche-cooling-unit-product', KvscheCoolingUnitProduct);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kvsche-glass-offer-popup"]) return;
  try {
    
  class KvscheGlassOffer extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      this.closeButton = this.querySelector('[data-glass-offer-close]');
      this.form = this.querySelector('form');
      this.submitButton = this.querySelector('.kvsche-glass-offer__cta');
      this.success = this.querySelector('[data-glass-offer-success]');
      this.successTemplate = this.querySelector('[data-glass-offer-success-template]');
      this.error = this.querySelector('[data-glass-offer-error]');
      this.designMode = this.dataset.designMode === 'true';
      this.successVisible = Boolean(this.success);

      if (!this.dialog) return;

      this.closeButton?.addEventListener('click', () => this.dismiss());
      this.form?.addEventListener('submit', (event) => this.submit(event), { capture: true });
      this.dialog.addEventListener('cancel', () => this.remember());
      this.dialog.addEventListener('click', (event) => {
        if (event.target === this.dialog && !this.successVisible) this.dismiss();
      });

      if (this.success) {
        this.rememberSubscribed();
        this.dialog.showModal();
        this.success.focus();
        return;
      }

      if (!this.error && this.wasSeen()) return;

      const delay = this.error || this.designMode ? 150 : Number(this.dataset.delay || 0);
      this.openTimer = window.setTimeout(() => this.open(), delay);
    }

    async submit(event) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      this.remember();

      if (this.submitButton) {
        this.submitButton.disabled = true;
        this.submitButton.setAttribute('aria-busy', 'true');
      }

      try {
        const response = await fetch(this.form.action, {
          method: this.form.method,
          body: new FormData(this.form),
          headers: { Accept: 'text/html' },
        });

        if (!response.ok || !response.url.includes('customer_posted=true')) {
          throw new Error('Customer form submission was not accepted');
        }

        this.showSuccess();
      } catch (error) {
        this.form.submit();
      }
    }

    showSuccess() {
      const content = this.form?.querySelector('.kvsche-glass-offer__content');
      const success = this.successTemplate?.content.cloneNode(true);

      if (!content || !success) return;

      content.replaceWith(success);
      this.success = this.querySelector('[data-glass-offer-success]');
      this.successVisible = true;
      this.rememberSubscribed();

      if (!this.dialog.open) this.dialog.showModal();
      this.success?.focus();
    }

    disconnectedCallback() {
      window.clearTimeout(this.openTimer);
    }

    wasSeen() {
      if (this.designMode) return false;

      try {
        return (
          window.sessionStorage.getItem(this.dataset.storageKey) === 'seen' ||
          window.localStorage.getItem(`${this.dataset.storageKey}-subscribed`) === 'true'
        );
      } catch (error) {
        return false;
      }
    }

    remember() {
      if (this.designMode) return;

      try {
        window.sessionStorage.setItem(this.dataset.storageKey, 'seen');
      } catch (error) {
        return;
      }
    }

    rememberSubscribed() {
      if (this.designMode) return;

      this.remember();

      try {
        window.localStorage.setItem(`${this.dataset.storageKey}-subscribed`, 'true');
      } catch (error) {
        return;
      }
    }

    open() {
      if (!this.isConnected || !this.dialog || this.dialog.open) return;
      if (!this.error && this.wasSeen()) return;
      this.remember();
      this.dialog.showModal();
      this.error?.focus();
    }

    dismiss() {
      if (!this.dialog?.open) return;
      this.remember();
      this.dialog.close();
    }
  }

  if (!customElements.get('kvsche-glass-offer')) {
    customElements.define('kvsche-glass-offer', KvscheGlassOffer);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
